module.exports = __webpack_public_path__ + "static/media/smiley-amber.06d15285.svg";